import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/advertising.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-attitude.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-communications.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-strategy.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-studies.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/brand-tracking.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/concept-testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/healthCare.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/market-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/market-launch.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/new-product.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/patient-insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/patient.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/product_testing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/healthCare/segmentation.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
